module.exports = __webpack_public_path__ + "static/media/branch-demo.2867c045.JPG";